export default {"src":"/_next/static/media/logo.f3403a2b.svg","height":24,"width":74};